import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import type { OrgRole } from '../lib/orgRoles';

interface Props {
  children: React.ReactNode;
  requirePlatformAdmin?: boolean;
  requireOrgRole?: OrgRole[];
}

export function ProtectedRoute({ children, requirePlatformAdmin, requireOrgRole }: Props) {
  const { user, loading, isAuthenticated } = useAuthContext();

  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;
  if (!isAuthenticated || !user) return <Navigate to="/login" replace />;
  if (requirePlatformAdmin && !user.isPlatformAdmin) return <Navigate to="/" replace />;
  if (requireOrgRole && user.orgRole && !requireOrgRole.includes(user.orgRole)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
